export default __webpack_public_path__ + "static/ppq-modal-images-8d70573582e715fec1d4e2a4fceb9b58.png";